var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "498.233 234.802 19.682 15.245",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "noded"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 1, 1176.164307, -79.052284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03978217,0,0,0.03978217,-658.51488,317.36166)",
    id: "layer1-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M -259.186 274.575 C -195.623 263.347 -143.123 254.055 -142.52 253.927 L -141.424 253.694 L -201.434 182.314 C -234.439 143.055 -261.444 110.782 -261.444 110.596 C -261.444 110.243 -199.478 -60.396 -199.13 -61.004 C -199.014 -61.206 -156.844 11.598 -96.909 115.479 C -40.796 212.735 5.467 292.922 5.897 293.674 L 6.678 295.04 L -184.039 295.015 L -374.756 294.991 L -259.186 274.575 L -259.186 274.575 Z M -488.068 252.808 C -488.068 252.707 -459.792 203.621 -425.232 143.728 L -362.395 34.831 L -289.166 -26.623 C -248.89 -60.422 -215.829 -88.118 -215.696 -88.168 C -215.564 -88.219 -216.094 -86.885 -216.874 -85.205 C -217.654 -83.525 -253.436 -6.775 -296.39 85.349 L -374.488 252.848 L -431.278 252.919 C -462.513 252.958 -488.068 252.908 -488.068 252.808 L -488.068 252.808 Z",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.282222,
      fill: "url(#noded)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.9f0fadcb0b9535e5e837cefcfa4eda09.svg";
export { ForwardRef as ReactComponent };